export default __webpack_public_path__ + "static/media/addon3.fbd8468c.webp";